var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaucify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 316.3 100",
    style: {
      enableBackground: "new 0 0 316.3 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M204.8,24.8c1.9,1.2,5,4.5,9.5,4.3c4.5-0.2,7-2.4,7-5.8c0-3.2-1.8-4.9-6.4-6.7 c-5.5-1.9-11-4.8-11.1-9.6c-0.1-2.2,0.6-4.4,2-6.1c-5.1,2.5-8.3,7.8-8,13.5c0,4.1,1.4,8.1,3.9,11.2l2.1,0.2L204.8,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232,14.3c0-5-1.6-8.6-4-11h-2.2l-0.7,1C224,3.7,221-0.3,215.7,0s-7.7,2.7-7.8,5.8 c-0.1,3.2,3.7,5.6,8.3,7.4c5.8,2.2,9.8,4.4,9.7,9.3c0,2.2-0.7,4.3-1.9,6.1C228.6,25.5,232,20.3,232,14.3L232,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M213.7,28.6c1.9,0,5.7-1.6,5.7-4.9c0-3.2-1.6-4.5-6.1-6.2c-5.5-1.9-9.2-5.7-9.3-10.4 c-0.1-2.2,0.6-4.4,2-6.1c-5.1,2.5-8.3,7.8-8,13.5c0,4.1,1.4,8.1,3.9,11.2l1.9-2C205.6,24.8,209.1,28.6,213.7,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232,14.3c0-4.8-1.5-8.4-3.8-10.9l-2.1,2c-1.1-0.6-3.9-5-10.4-5c-3,0-5.4,2.3-5.5,5.3 c-0.1,3.2,4.6,5.5,9.1,7.4c5,2.1,6.6,4.4,6.6,9.3c0.1,2.1-0.5,4.3-1.7,6C228.6,25.3,232,20.2,232,14.3L232,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M220.7,34.8h-15v49.9h21.1V40.9C226.8,37.5,224.1,34.8,220.7,34.8L220.7,34.8z M71,34.5 c-10,0-16.3,1.8-20.2,3.9v13.1h7C60.8,49,64,48.8,68,48.8c8.5,0,7.3,4.9,7.3,7.8c0,0-28.9-6.5-28.9,13.8c0,8.5,4.8,15.4,16.1,15.4 c6.6,0,9.5-1.4,13.1-5.7h0.4l2.3,3.6c0.3,0.5,0.9,0.8,1.6,0.8h15.4c-0.6-2.9,0-26.9,0-26.9C96.2,37.5,85.9,34.5,71,34.5z M71.1,74.1 c-3.1,0-4.9,0.3-4.9-4.5c0-7.6,8.8-4.7,8.8-4.7C75,74.1,75,74.1,71.1,74.1z M298.3,35.1c0,0-6.9,23.7-7.6,26.3h-0.3 c-0.5-2.4-8.1-26.3-8.1-26.3h-25.7v-2.4c0.1-0.4,1.6-3.8,8.4-2l0.8-12c-3.6-0.6-7.3-1-11-0.9c-3.4,0-7.4-0.1-12.8,2.7 c-6.3,3.2-5.4,7.2-5.4,12.8v1.8h-5.4v13.2h5.4v36.4h20.2V48.3h8.1l14.4,34.2l-7.2,13v4.5h20.4c0,0,17.3-42,23.7-60.1V35L298.3,35.1 L298.3,35.1z M130.2,69c0,0.5-0.4,0.9-0.9,0.9h-4.7c-2.4,0-5,0.8-5-6V35.7H99.2v32.6c0,2.3,0.3,4.6,0.8,6.8c0.4,1.9,1.2,3.7,2.3,5.3 c0.9,1.4,2,2.6,3.4,3.5c2.5,1.3,5.2,2.1,8,2.2c5.8,0.1,11.5-2,15.7-6c0.3,3.2,3.7,5.8,7,5.8h15v-50h-21.1L130.2,69L130.2,69z  M154.9,60.6c0,19.1,11.4,25.7,29.5,25.7c2.4,0,11.5-1.5,15.3-4.7V69.1h-7c0,0-0.8,3-8.2,3c-2.7,0-9-0.7-9-12.5 c0-0.5-0.5-10.4,9-10.4c6.8,0,8.2,2,8.2,2l7,0.1V38c-3.3-1.6-5.7-3.4-15.3-3.4C159.4,34.6,154.9,49.9,154.9,60.6L154.9,60.6z  M31,53.4c-8.8-0.9-13.1-1.5-13.1-3.3c0-2.5,1.1-2.9,7-2.9c8,0,8.7,2.2,8.7,2.2h7.1V37.9C37,36.5,32,34.5,25,34.5 c-17,0-25,6.4-25,14.7c0,7.1,0.5,14.1,10.8,17c7.4,2,14.6,1.6,14.6,3.6c0,1.9-4.3,2.8-7.8,2.8c-6.1,0-9.2-3.3-9.2-3.3H0.3L0.2,82.1 c5.9,2.1,12,3.1,18.3,3.1c16.8,0,24.7-4.5,24.7-19.8C43.1,62.3,39.7,54.3,31,53.4z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaucify);
export default __webpack_public_path__ + "static/media/saucify.aad61db605dd207d0227e1435b8900d7.svg";
export { ForwardRef as ReactComponent };